import { ComponentRef, EventEmitter } from '@angular/core';
import { DataProvidersResolver } from '@epicuro-next/data-providers/providers-registry';
import {
  ComponentsRelationshipService,
  resolveValues,
} from '@epicuro-next/platform/dynamic-value-resolving';
import { IdProviderService } from 'libs/platform/dynamic-value-resolving/src/lib/services/id-provider.service';
import { isObservable, of } from 'rxjs';

export function setInputsOnComponent(
  dataProvidersResolver: DataProvidersResolver,
  componentsRelationshipService: ComponentsRelationshipService,
  idProviderService: IdProviderService,
  componentRef: ComponentRef<unknown>,
  values: Record<string, unknown>,
) {
  const valuesToSetOnInputs = resolveValues(
    values,
    dataProvidersResolver,
    componentsRelationshipService,
    idProviderService,
    componentRef,
  );

  for (const key of Object.keys(valuesToSetOnInputs)) {
    const value = valuesToSetOnInputs[key];
    const inputExpectsObservable = key.endsWith('$');
    const isEventEmitter = value instanceof EventEmitter;

    if (isObservable(value) && !isEventEmitter) {
      if (inputExpectsObservable) {
        setInputOnComponent(componentRef, key, value);
      } else {
        // Completion of the stream should already be handled by now in some steps earlier.
        // Therefore no need for takeUntil or anything.
        value.subscribe((data) => {
          setInputOnComponent(componentRef, key, data);
        });
      }
    } else {
      if (inputExpectsObservable) {
        setInputOnComponent(componentRef, key, of(value));
      } else {
        setInputOnComponent(componentRef, key, value);
      }
    }
  }
}

export function setInputOnComponent(
  componentRef: ComponentRef<unknown>,
  key: string,
  value: unknown,
): void {
  componentRef.setInput(key, value);
  componentRef.changeDetectorRef.markForCheck();
  componentRef.changeDetectorRef.detectChanges();
}
